import { apiCall, apiPrefix } from "@services/API/Requests";
import { handleResponse } from "@services/API/StatusCodes";
import { MapBroadcastGroup } from "@services/API/MapData";
import { TranslateErrorMessage } from "@services/ErrorHandling";

export const getBroadcastGroupsData = async (
  setBroadcastGroupData: (data: any) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  currentPage: number,
  itemsPerPage: number,
  setTotalUsers: (count: number) => void,
) => {
  return apiCall({
    method: "get",
    url: `${apiPrefix}/broadcast_groups`,
    setLoading,
    onSuccess: (response) => {
      const broadcastGroups = response.data.broadcast_groups.map((group) => ({
        id: group.id,
        name: group.name,
        code: group.code,
        parent: group.parent ? group.parent.id : null,
        name_kana: group.name_kana,
      }));

      setTotalUsers(response.data.total_count);

      setBroadcastGroupData(broadcastGroups);
      const responseMessage = handleResponse(response, "一斉発信グループ");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const getFilteredBroadcastGroupData = async (
  setBroadcastUserData: (data: any) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  query: string,
) => {
  const uri = query
    ? `${apiPrefix}/broadcast_groups/?${query}`
    : `${apiPrefix}/broadcast_groups/`;

  return apiCall({
    method: "get",
    url: uri,
    setLoading,
    onSuccess: (response) => {
      const groups = response.data.map((group) => ({
        id: group.id,
        uid: group.uid,
        name: group.name,
      }));
      setBroadcastUserData(groups);
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const getBroadcastGroupData = async (
  setBroadcastGroupData: (data: any) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  broadcastGroupId: string,
) => {
  return apiCall({
    method: "get",
    url: `${apiPrefix}/broadcast_groups/${broadcastGroupId}`,
    setLoading,
    onSuccess: (response) => {
      const broadcastGroups = {
        id: response.data.id,
        name: response.data.name,
        code: response.data.code,
        parent: response.data.parent ? response.data.parent.id : null,
        name_kana: response.data.name_kana,
      };

      setBroadcastGroupData(MapBroadcastGroup(response.data));
      const responseMessage = handleResponse(response, "一斉発信グループ");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(TranslateErrorMessage(error));
    },
  });
};

export const putBroadcastGroupData = async (
  broadcastGroupData: any,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
) => {
  return apiCall({
    method: "put",
    url: `${apiPrefix}/broadcast_groups/${broadcastGroupData.id}`,
    setLoading,
    data: broadcastGroupData,
    onSuccess: (response) => {
      const responseMessage = handleResponse(response, "一斉発信グループ");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const postBroadcastGroupData = async (
  setBroadcastGroupData: (data: any) => void,
  broadcastGroupData: any,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
) => {
  return apiCall({
    method: "post",
    url: `${apiPrefix}/broadcast_groups`,
    setLoading,
    data: broadcastGroupData,
    onSuccess: (response) => {
      const broadcastGroup = {
        id: response.data.id,
        tenant_id: response.data.tenant_id,
        name: response.data.name,
        parent: response.data.parent ? response.data.parent.id : null,
        name_kana: response.data.name_kana,
        code: response.data.code,
      };

      setBroadcastGroupData(broadcastGroup);

      const responseMessage = handleResponse(response, "一斉発信グループ");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const deleteBroadcastGroupData = async (
  broadcastGroupId: string,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
) => {
  return apiCall({
    method: "delete",
    url: `${apiPrefix}/broadcast_groups/${broadcastGroupId}`,
    setLoading,
    onSuccess: (response) => {
      const responseMessage = handleResponse(response, "一斉発信グループ");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};
